import axios from 'axios'
export default {
  getRecentPosts() {
    return axios.get('https://www.its-silver.com/blog/archives/').then(res => {
      let html = res.data
      const htmlPattern = /<body.*?>([\S\s]*)<\/body>/g
      html = htmlPattern.exec(html)[1]
      let result = document.createElement('html')
      result.innerHTML = html
      let div = result.querySelector('#recents')
      // document.body.insertAdjacentHTML('beforeend', div.innerHTML)
      /**
       * @interface data [{POST}, {POST}, ...]
       */
      let data = []

      /**
       * @interface post {
       *   id,
       *   thumb,  缩略图
       *   title,
       *   date,
       *   href,
       *   cateHref,  分类l链接
       *   cate  分类
       * }
       *
       */
      let articles = div.querySelectorAll('article')
      Array.prototype.forEach.call(articles, (item, index) => {
        let post = {}
        post.id = index
        post.thumb = item.querySelector('.thumbnail').getAttribute('src')
        post.title = item.querySelector('.content > a').innerHTML
        post.date = new Date(item.querySelector('.content time').getAttribute('datetime'))
        post.href = item.querySelector('.content > a').getAttribute('href')
        post.cateHref = item.querySelector('.content .has-link-grey') && item.querySelector('.content .has-link-grey').href
        post.cate = item.querySelector('.content p > a') && item.querySelector('.content p > a').innerHTML
        data.push(post)
      })
      return data
    })
  }
}
